import { useEffect, useRef, useState } from "react";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { RadioButton } from "primereact/radiobutton";
import { Tag } from "primereact/tag";
import { Divider } from "primereact/divider";
import { Checkbox } from "primereact/checkbox";
import AdvancedOptions from "./AdvancedSearchForm";
import CandidateResults, { Candidate } from "./CandidateResult";
import { Toast } from "primereact/toast";
import { Dialog } from "primereact/dialog";
import MonsterCandidateProfile from "./Monstercandidateprofile";
import { Fetch } from "../../../shared/Fetch";
import { Skeleton } from "primereact/skeleton";
// import { stateWithCityWithZipCode } from "../model";
import { AutoComplete } from "primereact/autocomplete";
import { MultiSelect } from "primereact/multiselect";
import { stateWithCity } from "../model";

const recentHistory = [
  { id: 1, query: '("CA Plex" OR "CA-Plex" OR Plex or caplex)', date: "03/24/26 13:17:29" },
  { id: 2, query: '("CA Plex" OR "CA-Plex" OR Plex or caplex) in United States', date: "03/24/26 13:17:18" },
  { id: 3, query: '("CA Plex" OR "CA-Plex" OR Plex or caplex) in United States', date: "03/24/26 13:17:05" },
  { id: 4, query: '("IS-U" or isu) and sap', date: "03/23/26 18:08:47" },
  { id: 5, query: '("IS-U" or isu) and sap in United States', date: "03/23/26 18:06:37" },
];

const savedHistory = [
  { id: 1, query: '("CA Plex" OR "CA-Plex" OR Plex) in United States', date: "03/20/26 10:00:00" },
  { id: 2, query: '("IS-U" or isu) and sap in United States', date: "03/19/26 09:30:00" },
];

const radiusOptions = [
  { label: "10 miles", value: "10" },
  { label: "15 miles", value: "15" },
  { label: "20 miles", value: "20" },
  { label: "25 miles", value: "25" },
  { label: "30 miles", value: "30" },
  { label: "35 miles", value: "35" },
  { label: "40 miles", value: "40" },
  { label: "45 miles", value: "45" },
  { label: "50 miles", value: "50" },
  { label: "100 miles", value: "100" },
];

const resumeUpdatedOptions = [
  { label: "All Resumes", value: "all" },
  { label: "Today", value: "1440" },
  { label: "Within 1 day", value: "1440" },
  { label: "Within 2 days", value: "2880" },
  { label: "Within 3 days", value: "4320" },
  { label: "Within 1 week", value: "10080" },
  { label: "Within 1 month", value: "43200" },
  { label: "Within 3 months", value: "129600" },
  { label: "Within 6 months", value: "259200" },
  { label: "Within 9 months", value: "388800" },
  { label: "Within 12 months", value: "525600" },
];

const educationOptions = [
  { label: "All Education Levels", value: "all" },
  { label: "High School / GED", value: "hs" },
  { label: "Associate Degree", value: "associate" },
  { label: "Bachelor's Degree", value: "bachelor" },
  { label: "Master's Degree", value: "master" },
  { label: "Doctorate", value: "phd" },
];

const jobTypeOptions = [
  { label: "All Types", value: "all" },
  { label: "Full Time", value: "fulltime" },
  { label: "Part Time", value: "parttime" },
  { label: "Contract", value: "contract" },
  { label: "Seasonal", value: "seasonal" },
];

const travelOptions = [
  { label: "No Travel Required", value: "none" },
  { label: "Up to 25%", value: "25" },
  { label: "Up to 50%", value: "50" },
  { label: "Up to 75%", value: "75" },
  { label: "100% Travel", value: "100" },
];

const mockCandidates = [
  {
    id: 1,
    matchScore: 10.0,
    name: "Kevin Kelsey",
    location: "US-OH-Warren",
    currentTitle: "JavaScript / React Developer",
    company: "Turning Technologies",
    resumeUpdated: "06/14/22",
    experience: "7.5 Years",
    highestEducation: "High School or Equivalent",
    targetJobTitle: "-",
    desiredJobType: "-",
    desiredSalary: "-",
    relocation: "Will Relocate",
    authorization: "US",
    topSkills: [
      { name: "Check Processing", years: "2.6yrs" },
      { name: "Data Quality", years: "2.6yrs" },
      { name: "Background Investigation", years: "2.6yrs" },
    ],
  },
  {
    id: 2,
    matchScore: 10.0,
    name: "Eduardo Colon",
    location: "US-OH-Columbus",
    currentTitle: "Chef-Owner",
    company: "Web Focus",
    resumeUpdated: "07/20/22",
    experience: "14.1 Years",
    highestEducation: "Bachelors Degree",
    targetJobTitle: "-",
    desiredJobType: "-",
    desiredSalary: "-",
    relocation: "Won't Relocate",
    authorization: "US",
    topSkills: [
      { name: "Object Oriented Programming (OOP)", years: "14.1yrs" },
      { name: "Java", years: "14.1yrs" },
      { name: "REST (Representational State Transfer)", years: "14.1yrs" },
    ],
  },
  {
    id: 3,
    matchScore: 10.0,
    name: "Abhijeet Rathod",
    location: "US-CA-San Francisco",
    currentTitle: "Senior Full Stack Developer",
    company: "Google - (Youtube)",
    resumeUpdated: "04/03/26",
    experience: "5.2 Years",
    highestEducation: "-",
    targetJobTitle: "-",
    desiredJobType: "-",
    desiredSalary: "-",
    relocation: "Won't Relocate",
    authorization: "-",
    topSkills: [
      { name: "REST (Representational State Transfer)", years: "5.1yrs" },
      { name: "Software Development", years: "5.1yrs" },
      { name: "Microservices", years: "4.3yrs" },
    ],
  },
  {
    id: 4,
    matchScore: 10.0,
    name: "Rajesh Ibba",
    location: "US-GA-Milton",
    currentTitle: "Principal Consultant",
    company: "Genpact",
    resumeUpdated: "04/03/26",
    experience: "14.5 Years",
    highestEducation: "Bachelors Degree",
    targetJobTitle: "-",
    desiredJobType: "-",
    desiredSalary: "-",
    relocation: "Will Relocate",
    authorization: "US",
    topSkills: [
      { name: "User Interface/Experience (UI/UX)", years: "14.3yrs" },
      { name: "JavaScript", years: "11.6yrs" },
      { name: "Internet Application", years: "11.2yrs" },
    ],
  },
  {
    id: 5,
    matchScore: 10.0,
    name: "Kiroloss Francis",
    location: "US-GA-Buford",
    currentTitle: "eCommerce System Manager",
    company: "Delta Apparel",
    resumeUpdated: "07/25/19",
    experience: "8.6 Years",
    highestEducation: "-",
    targetJobTitle: "-",
    desiredJobType: "-",
    desiredSalary: "-",
    relocation: "Won't Relocate",
    authorization: "-",
    topSkills: [
      { name: "Software Development", years: "6.6yrs" },
      { name: "SQL (Structured Query Language)", years: "4.5yrs" },
      { name: "Microsoft ASP.NET", years: "4.5yrs" },
    ],
  },
];

const GeometricPattern = () => (
  <svg style={{ position: "absolute", inset: 0, width: "100%", height: "100%", opacity: 0.18, pointerEvents: "none" }} xmlns="http://www.w3.org/2000/svg">
    <defs>
      <pattern id="geo" x="0" y="0" width="80" height="80" patternUnits="userSpaceOnUse">
        <polygon points="0,0 40,0 0,40" fill="none" stroke="#a78bfa" strokeWidth="1" />
        <polygon points="80,80 40,80 80,40" fill="none" stroke="#a78bfa" strokeWidth="1" />
        <circle cx="60" cy="20" r="14" fill="none" stroke="#a78bfa" strokeWidth="1" />
        <circle cx="20" cy="60" r="14" fill="none" stroke="#a78bfa" strokeWidth="1" />
        <line x1="0" y1="80" x2="80" y2="0" stroke="#a78bfa" strokeWidth="0.5" />
        <polygon points="40,0 80,0 80,40" fill="#6d28d9" opacity="0.4" />
        <polygon points="0,40 0,80 40,80" fill="#6d28d9" opacity="0.4" />
      </pattern>
    </defs>
    <rect width="100%" height="100%" fill="url(#geo)" />
  </svg>
);

interface SearchParams {
  jobTitle?: string;
  skills?: string;
  booleanEntries?: { name: string; importance: string };
  location?: any[];
  radius?: string;
  resumeUpdated?: string;
  education?: string;
  jobType?: any;
  travel?: string;
  relocation?: boolean;
  searchType?: string;
  booleanSkills?: string;
  [key: string]: any;
}

const ProfileSkeleton = () => (
  <div style={{ padding: "16px" }}>
    <div style={{ display: "flex", gap: "16px", marginBottom: "24px" }}>
      <Skeleton shape="circle" size="64px" />
      <div style={{ flex: 1 }}>
        <Skeleton width="200px" height="20px" style={{ marginBottom: "8px" }} />
        <Skeleton width="140px" height="16px" style={{ marginBottom: "8px" }} />
        <Skeleton width="180px" height="16px" />
      </div>
    </div>
    <Skeleton width="100%" height="120px" style={{ marginBottom: "16px" }} />
    <Skeleton width="100%" height="80px" style={{ marginBottom: "16px" }} />
    <Skeleton width="100%" height="80px" />
  </div>
);

interface SkillEntry {
  id: number;
  name: string;
  importance: "Required" | "NiceToHave";
}

type LocationType = {
  State: string;
  City: string;
};

const SearchMonster = ({ onSwitchToClassic, onSwitchToPower, reload }: any) => {
  const [searchType, setSearchType] = useState("semantic");
  const [jobTitle, setJobTitle] = useState("");
  // const [skills, setSkills] = useState("");
  const [booleanEntries, setBooleanEntries] = useState({ name: "", importance: "Required" } as { name: string; importance: string });
  const [skillEntries, setSkillEntries] = useState<SkillEntry[]>([{ id: 1, name: "", importance: "NiceToHave" }]);
  const [location, setLocation] = useState<Array<string>>([]);
  const [suggestions, setSuggestions] = useState<LocationType[]>([]);
  const [radius, setRadius] = useState<string>("50");
  const [showAdvanced, setShowAdvanced] = useState(false);
  // const [booleanSkills, setBooleanSkills] = useState("");
  // const [activeTab, setActiveTab] = useState(0);
  const [resumeUpdated, setResumeUpdated] = useState("all");
  const [education, setEducation] = useState("all");
  const [jobType, setJobType] = useState("all");
  const [travel, setTravel] = useState("none");
  const [relocation, setRelocation] = useState(false);
  const [showResults, setShowResults] = useState(false);
  const [apiResults, setApiResults] = useState<Candidate[]>([]);
  const [totalResults, setTotalResults] = useState(0);
  const [totalReturned, setTotalReturned] = useState(0);
  const [selectedCandidate, setSelectedCandidate] = useState<Candidate | null>(null);
  const [profileVisible, setProfileVisible] = useState(false);
  const [first, setFirst] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [profileLoading, setProfileLoading] = useState(false);
  const [filters, setFilters] = useState<any>({});
  const [jobTitleEntries, setJobTitleEntries] = useState<{ id: number; name: string }[]>([{ id: 1, name: "" }]);
  const nextJobTitleId = useRef(2);
  const toast = useRef<any>(null);
  const [useageData, setUseageData] = useState({
    customerId: 0,
    quota: 0,
    viewsConsumed: 0,
    viewsRemaining: 0,
  });
  const nextSkillId = useRef(2);

  const addSkill = () => {
    const lastSkill = skillEntries[skillEntries.length - 1];
    if (!lastSkill?.name?.trim()) {
      toast.current?.show({
        severity: "warn",
        summary: "Empty Skill",
        detail: "Please enter a skill before adding another.",
        life: 2500,
      });
      return;
    }
    setSkillEntries((prev) => [...prev, { id: nextSkillId.current++, name: "", importance: "NiceToHave" }]);
  };
  const removeSkill = (id: number) => {
    setSkillEntries((prev) => prev.filter((s) => s.id !== id));
  };

  const updateSkillName = (id: number, name: string) => {
    setSkillEntries((prev) => prev.map((s) => (s.id === id ? { ...s, name } : s)));
  };

  const toggleSkillImportance = (id: number) => {
    setSkillEntries((prev) => prev.map((s) => (s.id === id ? { ...s, importance: s.importance === "Required" ? "NiceToHave" : "Required" } : s)));
  };

  const addJobTitle = () => {
    const last = jobTitleEntries[jobTitleEntries.length - 1];
    if (!last?.name?.trim()) {
      toast.current?.show({
        severity: "warn",
        summary: "Empty Job Title",
        detail: "Please enter a job title before adding another.",
        life: 2500,
      });
      return;
    }
    setJobTitleEntries((prev) => [...prev, { id: nextJobTitleId.current++, name: "" }]);
  };

  const removeJobTitle = (id: number) => {
    setJobTitleEntries((prev) => prev.filter((j) => j.id !== id));
  };

  const updateJobTitle = (id: number, name: string) => {
    setJobTitleEntries((prev) => prev.map((j) => (j.id === id ? { ...j, name } : j)));
  };

  const checkUsageBeforeSearch = async () => {
    try {
      const response = await Fetch("Monster/getViewAccess", "GET", null, `profile_ID=forViewCount`, toast);
      if (response) {
        const data = await response.json();
        if (data.isAccess === true) {
          setUseageData({
            customerId: 0,
            quota: data.maxViewsAllowed || 0,
            viewsConsumed: data.viewsConsumed || 0,
            viewsRemaining: (data.maxViewsAllowed || 0) - (data.viewsConsumed || 0),
          });
        } else if (data.isAccess === false) {
          toast?.current.show({ severity: "error", detail: data.message || "Something Went Wrong or Your Do Not Have View Limit", life: 3000 });
        }
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    checkUsageBeforeSearch();
  }, []);

  // ─── FULL REPLACEMENT for loadTableData inside SearchMonster.tsx ───────────────

  const loadTableData = async (params: SearchParams = {}) => {
    setIsLoading(true);

    // ── Security Clearances ─────────────────────────────────────────────────
    const clearanceIDMap: Record<string, number> = {
      unspecified: 2,
      activeConfidential: 3,
      activeSecret: 4,
      activeTopSecret: 5,
      activeTopSecretSCI: 6,
      activeTSSCICIPoly: 19,
      activeTSSCIFSPoly: 20,
      otherActiveClearance: 21,
    };

    const securityClearance = (() => {
      if (!params?.clearance) return [];
      if (Array.isArray(params.clearance)) return params.clearance;
      return Object.entries(params.clearance)
        .filter(([_, v]) => v === true)
        .map(([k]) => ({ clearanceId: clearanceIDMap[k], countryAbbrev: "US" }))
        .filter((x) => x.clearanceId);
    })();

    // ── Job Types ───────────────────────────────────────────────────────────
    const jobTypeAPIMap: Record<string, string> = {
      fullTime: "WantsPermanent",
      partTime: "WantsTemp",
      tempContract: "WantsContract",
      intern: "WantsIntern",
      seasonal: "WantsSeasonal",
    };

    const jobTypes = (() => {
      if (!params?.jobType) return [];
      if (typeof params.jobType === "object" && !Array.isArray(params.jobType)) {
        return Object.entries(params.jobType)
          .filter(([_, v]) => v === true)
          .map(([k]) => jobTypeAPIMap[k])
          .filter(Boolean);
      }
      if (typeof params.jobType === "string") {
        if (params.jobType === "all" || !params.jobType) return [];
        const simpleMap: Record<string, string> = {
          fulltime: "WantsPermanent",
          parttime: "WantsTemp",
          contract: "WantsContract",
          intern: "WantsIntern",
          seasonal: "WantsSeasonal",
        };
        return [simpleMap[params.jobType]].filter(Boolean);
      }
      return [];
    })();

    // ──  Citizenship → legalStatuses ────────────────────────────────────────
    const citizenshipAPIMap: Record<string, string> = {
      usCitizen: "Citizen",
      permanentResident: "PermanentResident",
    };

    const legalStatuses = (() => {
      if (!params?.citizenship) return [];

      if (typeof params.citizenship === "string") {
        const mapped = citizenshipAPIMap[params.citizenship];
        return mapped ? [{ legalStatusName: mapped, countryAbbrev: "US" }] : [];
      }

      if (typeof params.citizenship === "object" && !Array.isArray(params.citizenship)) {
        return Object.entries(params.citizenship)
          .filter(([_, v]) => v === true)
          .map(([k]) => ({ legalStatusName: citizenshipAPIMap[k], countryAbbrev: "US" }))
          .filter((x) => x.legalStatusName);
      }

      return [];
    })();
    // ──  Resume / activity ages ──────────────────────────────────────────────

    const minuteKeyMap: Record<string, number> = {
      "24h": 1440,
      "7d": 10080,
      "30d": 43200,
      "90d": 129600,
    };

    const resolveMinutes = (val: any): number | undefined => {
      if (!val || val === "all") return undefined;
      if (minuteKeyMap[val]) return minuteKeyMap[val];
      const n = Number(val);
      return Number.isFinite(n) && n > 0 ? n : undefined;
    };

    const resumeUpdatedMaxAge = resolveMinutes(params?.resumeUpdatedMaxAge ?? params?.resumeUpdated);
    const resumeUpdatedMinAge = resolveMinutes(params?.resumeUpdatedMinAge);
    const lastActiveMaxAge = resolveMinutes(params?.lastActiveMaxAge);

    // ──  Years of experience ─────────────────────────────────────────────────

    const yearsOfExperience = (() => {
      let v = params?.yearsOfExperience ?? params?.yearsExp;
      if (!v) return undefined;
      if (typeof v === "object" && v.expression) {
        v = v.expression;
      }
      v = String(v).trim();
      if (!v) return undefined;
      if (v.includes("-")) {
        return { expression: v, importance: "Required" };
      }
      if (v.startsWith(">")) {
        const num = v.replace(">", "").trim();
        return { expression: `${num}+`, importance: "Required" };
      }
      if (v.startsWith("<")) {
        const num = v.replace("<", "").trim();
        return { expression: `0-${num}`, importance: "Required" };
      }
      if (!isNaN(Number(v))) {
        return { expression: `${v}`, importance: "Required" };
      }
      return undefined;
    })();

    // ──  Work Authorization ──────────────────────────────────────────────────
    const workAuthorizations = (() => {
      if (!params?.workAuth || params.workAuth === "all") return [];
      return [{ workStatus: "AuthorizedToWorkForAnyEmployer", countryAbbrev: params.workAuth }];
    })();

    // ──  Skills (semantic) ───────────────────────────────────────────────────

    const skills = (() => {
      if (params?.searchType === "boolean") return undefined;
      if (!Array.isArray(params?.skillEntries)) return undefined;
      const filtered = params.skillEntries.filter((s: SkillEntry) => s.name?.trim());
      if (!filtered.length) return undefined;
      return filtered.map((s: SkillEntry) => ({
        name: s.name.trim(),
        importance: s.importance, // already correct API value
      }));
    })();

    // ──  Boolean expression ──────────────────────────────────────────────────

    const booleanExpression = (() => {
      if (params?.searchType !== "boolean") return undefined;
      const expr = params?.booleanEntries?.name ?? "";
      if (!expr) return undefined;
      return { expression: String(expr), importance: "Required" };
    })();
    // ── Salary ──────────────────────────────────────────────────────────────
    const salary = {
      minimum: params?.salary?.minimum ? params?.salary?.minimum : null,
      currencyAbbrev: "USD",
      includeResumesWithoutSalary: params?.salary?.includeResumesWithoutSalary ?? params?.includeWithoutSalary ?? true,
    };

    // ──  Education ──────────────────────────────────────────────────────────

    const simpleEducationMap: Record<string, string> = {
      hs: "HighSchoolOrEquivalent",
      associate: "AssociateDegree",
      bachelor: "BachelorsDegree",
      master: "MastersDegree",
      phd: "Doctorate",
    };

    const minEducationLevel = (() => {
      if (params?.minEducationLevel) return params.minEducationLevel;
      if (params?.education && params.education !== "all") return simpleEducationMap[params.education];
      return undefined;
    })();

    // ──  Travel ─────────────────────────────────────────────────────────────

    const travelMap: Record<string, string> = {
      "25": "UpTo25PercentTravel",
      "50": "UpTo50PercentTravel",
      "75": "UpTo75PercentTravel",
      "100": "OneHundredPercentTravel",
    };

    const willingnessToTravel = (() => {
      if (params?.willingnessToTravel) return params.willingnessToTravel;
      if (params?.travel && params.travel !== "none") return travelMap[params.travel];
      return undefined;
    })();

    // ── Language Proficiency ────────────────────────────────────────────────────
    const languageProficiencyLevels = (() => {
      if (params?.languageProficiencyLevels) return params?.languageProficiencyLevels;
      return null;
    })();

    // ── Build final request ────────────────────────────────────────────────────
    const requestBody = {
      country: "US",
      searchType: "Semantic",
      semantic: {
        // ── Titles ──────────────────────────────────────────────────────────
        // jobTitles: params?.searchType === "boolean" ? [] : params?.jobTitle ? [params.jobTitle.trim()] : [],
        // jobTitles: params?.jobTitle ? [params.jobTitle.trim()] : [],
        // jobTitles: params?.jobTitle
        //   ? params.jobTitle
        //       .split(",")
        //       .map((t: string) => t.trim())
        //       .filter(Boolean)
        //   : [],
        jobTitles:
          params?.searchType === "boolean"
            ? []
            : params?.jobTitle
                ?.split(",")
                .map((t: string) => t.trim())
                .filter(Boolean) ?? [],

        // ── Skills (semantic mode only) ──────────────────────────────────────
        ...(skills && { skills }),

        // ── Boolean expression (boolean mode only) ───────────────────────────
        ...(booleanExpression && { booleanExpression }),

        // ── Location ────────────────────────────────────────────────────────
        ...(params?.location
          ? {
              locations: params?.location?.map((loc: any) => {
                return {
                  city: loc?.City,
                  state: loc?.State,
                  country: "US",
                  // postalCode: loc?.Zip,
                  radius: parseInt(params.radius ?? "50"),
                  radiusUnit: "Miles",
                };
              }),
            }
          : { locations: [] }),

        // ── Resume / activity age ────────────────────────────────────────────
        ...(resumeUpdatedMaxAge !== undefined && { resumeUpdatedMaximumAge: resumeUpdatedMaxAge }),
        ...(resumeUpdatedMinAge !== undefined && { resumeUpdatedMinimumAge: resumeUpdatedMinAge }),
        ...(lastActiveMaxAge !== undefined && { lastActiveMaximumAge: lastActiveMaxAge }),

        // ── Experience ───────────────────────────────────────────────────────
        ...(yearsOfExperience && { yearsOfExperience }),

        // ── Candidate name ───────────────────────────────────────────────────
        ...(params?.candidateName && { candidateName: params.candidateName }),

        // ── Flags ────────────────────────────────────────────────────────────
        ...(typeof params?.limitVeterans === "boolean" && {
          veteranCandidates: params.limitVeterans,
        }),
        ...(typeof params?.limitRelocate === "boolean" && {
          willingnessToRelocate: params.limitRelocate === true ? params.limitRelocate : null,
        }),

        // ── Arrays (only include when non-empty) ─────────────────────────────
        ...(workAuthorizations.length > 0 && { workAuthorizations }),
        ...(legalStatuses.length > 0 && { legalStatuses }),
        ...(securityClearance.length > 0 && { securityClearances: securityClearance }),
        ...(jobTypes.length > 0 && { jobTypes }),

        // ── Education & travel ───────────────────────────────────────────────
        ...(minEducationLevel && { minEducationLevel }),
        ...(willingnessToTravel && { willingnessToTravel }),

        // ── Language ───────────────────────────────────────────────
        ...(languageProficiencyLevels && { languageProficiencyLevels }),

        // ── Salary ───────────────────────────────────────────────────────────
        salary,

        // ── Paging ───────────────────────────────────────────────────────────
        page: params?.pageNum ?? 1,
        perPage: 25,
      },
    };

    console.log("Request Body :->", requestBody);
    try {
      const response = await Fetch("Monster/searchResumes", "POST", requestBody, "", toast);

      if (response) {
        const dataA: any = await response.json();
        const data: any = dataA.candidates || [];
        const raw: any[] = data.resumes ?? data.candidates ?? (Array.isArray(data) ? data : []);

        const mapMonsterToCandidateResult = (item: any): Candidate => ({
          id: item.identity?.textResumeID ?? item.resumeID ?? item.id,
          textResumeID: item.identity?.textResumeID,
          matchScore: item.relevance?.score ?? 0,
          name: item.identity?.name ?? "Unknown",
          location: [item.location?.city, item.location?.state, item.location?.country].filter(Boolean).join("-"),
          currentTitle: item.relevance?.experience?.title?.name ?? "—",
          company: item.relevance?.experience?.company?.name ?? "—",
          resumeUpdated: item.identity?.resumeModifiedDate ? new Date(item.identity.resumeModifiedDate).toLocaleDateString("en-US") : "—",
          experience: item.yearsOfExperience ? `${item.yearsOfExperience} Years` : "—",
          highestEducation: item.degree ?? "—",
          targetJobTitle: "—",
          desiredJobType: "—",
          desiredSalary: "—",
          relocation: item.location?.willRelocate ? "Will Relocate" : "Won't Relocate",
          authorization: item.location?.workAuthorizations?.[0]?.country ?? "—",
          topSkills: (item.relevance?.skills ?? []).slice(0, 3).map((s: any) => ({
            name: s.name,
            years: `${s.yearsOfExperience?.toFixed(1) ?? "?"}yrs`,
          })),
        });

        setApiResults(raw.map(mapMonsterToCandidateResult));
        setShowResults(true);
        setTotalResults(dataA?.boards?.[0]?.matched ?? data.total ?? raw.length ?? 0);
        setTotalReturned(dataA?.boards?.[0]?.returned ?? 0);
      }
    } catch (err) {
      console.error("Search failed:", err);
      toast.current?.show({ severity: "error", summary: "Search Failed", detail: "Something went wrong.", life: 3000 });
    } finally {
      setIsLoading(false);
    }
  };

  const getViewAccess = async (candidate: Candidate) => {
    if (!candidate.textResumeID) {
      toast.current?.show({
        severity: "warn",
        summary: "Missing ID",
        detail: "No resume ID available for this candidate.",
        life: 3000,
      });
      return;
    }

    try {
      const response = await Fetch("Monster/getViewAccess", "GET", null, `profile_ID=${candidate.textResumeID}`, toast);

      if (!response) return;

      const data = await response.json();

      if (data.isAccess) {
        // setSelectedCandidate(candidate);
        setSelectedCandidate(null);
        setProfileLoading(true);
        setProfileVisible(true);
        setTimeout(() => {
          setSelectedCandidate(candidate);
        }, 0);
        setUseageData({
          customerId: 0,
          quota: data.maxViewsAllowed || 0,
          viewsConsumed: data.viewsConsumed || 0,
          viewsRemaining: (data.maxViewsAllowed || 0) - (data.viewsConsumed || 0),
        });
      } else {
        toast.current?.show({
          severity: "error",
          summary: "Access Denied",
          detail: data.message || "You do not have access to view this profile.",
          life: 4000,
        });
      }
    } catch (err) {
      console.error("getViewAccess error:", err);
    }
  };

  const onPage = async (page: number) => {
    await loadTableData({
      // jobTitle,
      jobTitle: jobTitleEntries
        .filter((j) => j.name.trim())
        .map((j) => j.name.trim())
        .join(", "),
      skillEntries,
      location,
      radius,
      searchType,
      booleanEntries,
      limitRelocate: filters.limitRelocate ?? relocation,
      limitVeterans: filters.limitVeterans ?? false,
      workAuth: filters.workAuth ?? "all",
      careerLevel: filters.careerLevel,
      yearsOfExperience: filters.yearsOfExperience,
      yearsExp: filters.yearsExp,
      expRequired: filters.expRequired,
      resumeUpdatedMaxAge: filters.resumeUpdatedMaxAge,
      resumeUpdatedMinAge: filters.resumeUpdatedMinAge,
      lastActiveMaxAge: filters.lastActiveMaxAge,
      candidateName: filters.candidateName,
      jobType: filters.jobType,
      citizenship: filters.citizenship,
      clearance: filters.clearance ?? filters.securityClearances,
      salary: filters.salary,
      salaryAmount: filters.salaryAmount,
      includeWithoutSalary: filters.includeWithoutSalary,
      travel: filters.willingnessToTravel ?? filters.travel,
      education: filters.minEducationLevel ?? filters.education,
      minEducationLevel: filters.minEducationLevel,
      willingnessToTravel: filters.willingnessToTravel,
      languageProficiencyLevels: filters.languageProficiencyLevels,
      degrees: filters.degrees,
      companies: filters.companies,
      jobTenure: filters.jobTenure,
      pageNum: page,
    });
  };

  // const searchLocation = (event: { query: string }) => {
  //   const query = event.query.trim().toLowerCase();

  //   if (!query) {
  //     setSuggestions([]);
  //     return;
  //   }

  //   let filtered: LocationType[] = [];

  //   // 🔹 If user types number → search ZIP
  //   if (/^\\d+$/.test(query)) {
  //     filtered = stateWithCity?.filter((item:any) => item.Zip.startsWith(query));
  //   }
  //   // 🔹 If user types text → search State or City
  //   else {
  //     filtered = stateWithCity?.filter((item:any) => item.State.toLowerCase().includes(query) || item.City.toLowerCase().includes(query) || item.Zip.startsWith(query));
  //   }

  //   // 🔹 Limit to top 10
  //   setSuggestions(filtered.slice(0, 50));
  // };
  const searchLocation = (event: { query: string }) => {
    const query = event.query.trim().toLowerCase();

    if (!query) {
      setSuggestions([]);
      return;
    }

    let filtered: LocationType[] = stateWithCity?.filter((item: any) => item.State.toLowerCase().includes(query) || item.City.toLowerCase().includes(query));

    setSuggestions(filtered.slice(0, 50));
  };

  //   useEffect(() => {
  //   loadTableData();
  // }, []);
  return (
    <div style={{ fontFamily: "'IBM Plex Sans', sans-serif", backgroundColor: "#f3f4f6" }}>
      {/* ── Hero Banner ── */}
      {showResults === false && (
        <div style={{ position: "relative", backgroundColor: "#1e0a3c", padding: "48px 32px 52px", overflow: "hidden" }}>
          <GeometricPattern />

          <h1
            style={{
              position: "relative",
              textAlign: "center",
              color: "#fff",
              fontSize: "26px",
              fontWeight: 700,
              marginBottom: "28px",
              letterSpacing: "0.01em",
            }}
          >
            Monster Search helps you connect with the right candidates - now.
          </h1>

          {/* ── Search Bar ── */}
          <div
            style={{
              position: "relative",
              maxWidth: "1100px",
              margin: "0 auto",
              backgroundColor: "#fff",
              borderRadius: "6px",
              display: "flex",
              overflow: "hidden",
              boxShadow: "0 4px 24px rgba(0,0,0,0.35)",
            }}
          >
            {searchType === "semantic" && (
              <div style={{ flex: "1 1 0", borderRight: "1px solid #e5e7eb", padding: "10px 14px" }}>
                <div style={{ fontSize: "10px", fontWeight: 700, color: "#6b21a8", textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: "6px" }}>JOB TITLE</div>

                <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
                  {jobTitleEntries.map((jt, idx) => (
                    <div key={jt.id} style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                      {/* remove button (hidden for first row) */}
                      {jobTitleEntries.length > 1 ? (
                        <button
                          onClick={() => removeJobTitle(jt.id)}
                          style={{
                            background: "none",
                            border: "none",
                            cursor: "pointer",
                            color: "#9ca3af",
                            padding: "0 2px",
                            fontSize: "14px",
                            lineHeight: 1,
                            flexShrink: 0,
                          }}
                          title="Remove job title"
                        >
                          ×
                        </button>
                      ) : (
                        <span style={{ width: "18px", flexShrink: 0 }} />
                      )}

                      <InputText
                        value={jt.name}
                        onChange={(e) => updateJobTitle(jt.id, e.target.value)}
                        placeholder={idx === 0 ? "Cook, Developer, Nurse" : "Add title..."}
                        className="border-none shadow-none p-0"
                        style={{ flex: 1, fontSize: idx === 0 ? "16px" : "14px", color: "black", fontWeight: "bolder", minWidth: 0 }}
                      />
                    </div>
                  ))}
                </div>

                <button
                  onClick={addJobTitle}
                  style={{
                    marginTop: "6px",
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                    color: "#7c3aed",
                    fontSize: "11px",
                    fontWeight: 600,
                    padding: "2px 0",
                    textDecoration: "underline",
                  }}
                >
                  + Add another job title
                </button>
              </div>
            )}

            {searchType === "semantic" ? (
              <div style={{ flex: "1.5 1 0", borderRight: "1px solid #e5e7eb", padding: "10px 14px", minWidth: 0 }}>
                <div style={{ fontSize: "10px", fontWeight: 700, color: "#6b21a8", textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: "6px" }}>SKILLS / KEYWORDS</div>

                {/* skill rows */}
                <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
                  {skillEntries.map((skill, idx) => (
                    <div key={skill.id} style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                      {/* remove button (hidden for first row) */}
                      {skillEntries.length > 1 ? (
                        <button
                          onClick={() => removeSkill(skill.id)}
                          style={{
                            background: "none",
                            border: "none",
                            cursor: "pointer",
                            color: "#9ca3af",
                            padding: "0 2px",
                            fontSize: "14px",
                            lineHeight: 1,
                            flexShrink: 0,
                          }}
                          title="Remove skill"
                        >
                          ×
                        </button>
                      ) : (
                        <span style={{ width: "18px", flexShrink: 0 }} />
                      )}

                      {/* skill input */}
                      <InputText
                        value={skill.name}
                        onChange={(e) => updateSkillName(skill.id, e.target.value)}
                        placeholder={idx === 0 ? "e.g. Java, React, SQL" : "Add skill..."}
                        className="border-none shadow-none p-0"
                        style={{ flex: 1, fontSize: "14px", color: "black", fontWeight: 600, minWidth: 0 }}
                      />

                      {/* Required / Nice to have toggle */}
                      <button
                        onClick={() => toggleSkillImportance(skill.id)}
                        style={{
                          flexShrink: 0,
                          display: "inline-flex",
                          alignItems: "center",
                          gap: "5px",
                          padding: "3px 8px",
                          borderRadius: "20px",
                          border: `1.5px solid ${skill.importance === "Required" ? "#7c3aed" : "#16a34a"}`,
                          backgroundColor: skill.importance === "Required" ? "#ede9fe" : "#f0fdf4",
                          color: skill.importance === "Required" ? "#6d28d9" : "#15803d",
                          fontSize: "10px",
                          fontWeight: 700,
                          cursor: "pointer",
                          whiteSpace: "nowrap",
                          letterSpacing: "0.04em",
                          transition: "all 0.15s",
                        }}
                        title="Click to toggle Required / Nice to have"
                      >
                        {/* small circular icon like Monster UI */}
                        <span
                          style={{
                            width: "13px",
                            height: "13px",
                            borderRadius: "50%",
                            border: `2px solid ${skill.importance === "Required" ? "#7c3aed" : "#16a34a"}`,
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: "8px",
                          }}
                        >
                          {skill.importance === "Required" ? "R" : "N"}
                        </span>
                        {skill.importance === "Required" ? "Required" : "Nice to have"}
                      </button>
                    </div>
                  ))}
                </div>

                {/* Add another skill link */}
                <button
                  onClick={addSkill}
                  style={{
                    marginTop: "6px",
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                    color: "#7c3aed",
                    fontSize: "11px",
                    fontWeight: 600,
                    padding: "2px 0",
                    textDecoration: "underline",
                  }}
                >
                  + Add another skill or keyword
                </button>
              </div>
            ) : (
              // Boolean mode — keep original single input
              <div style={{ flex: "3 1 0", borderRight: "1px solid #e5e7eb", padding: "10px 14px" }}>
                <div style={{ fontSize: "10px", fontWeight: 700, color: "#6b21a8", textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: "4px" }}>BOOLEAN</div>
                <InputText
                  value={booleanEntries?.name ?? ""}
                  onChange={(e) => setBooleanEntries({ name: e.target.value, importance: "Required" })}
                  placeholder="(e.g. Sales AND Marketing NOT Audit)"
                  className="w-full border-none shadow-none p-0"
                  style={{ fontSize: "16px", color: "black", fontWeight: "bolder" }}
                />
              </div>
            )}

            <div style={{ flex: "1.2 1 0", borderRight: "1px solid #e5e7eb", padding: "10px 14px" }}>
              <div style={{ fontSize: "10px", fontWeight: 700, color: "#6b21a8", textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: "4px" }}>LOCATION</div>
              {/* <InputText value={location} onChange={(e) => setLocation(e.target.value)} placeholder="City, State or Zip" className="w-full border-none shadow-none p-0" style={{ fontSize: "16px", color: "black", fontWeight: "bolder" }} /> */}
              {/* <Dropdown value={location} options={stateWithCityWithZipCode} onChange={(e) => setLocation(e.value)} className="w-full border-none shadow-none" style={{ fontSize: "16px", color: "black", fontWeight: "bolder" }} /> */}
              <AutoComplete
                value={location}
                suggestions={suggestions}
                completeMethod={searchLocation}
                field="City" // default display (overridden below)
                onChange={(e) => setLocation(e.value)}
                // dropdown
                multiple
                itemTemplate={(item: LocationType) => (
                  <div>
                    <strong>{item.City}</strong>, {item.State}
                  </div>
                )}
                placeholder="Search by City, State or ZIP"
                className="border-none"
                style={{ width: "20rem" }}
              />
            </div>

            <div style={{ flex: "0.8 1 0", borderRight: "1px solid #e5e7eb", padding: "10px 14px" }}>
              <div style={{ fontSize: "10px", fontWeight: 700, color: "#6b21a8", textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: "4px" }}>RADIUS</div>
              <Dropdown value={radius} options={radiusOptions} onChange={(e) => setRadius(e.value)} className="w-full border-none shadow-none" style={{ fontSize: "16px", color: "black", fontWeight: "bolder" }} />
            </div>

            <Button
              label="SEARCH"
              onClick={async () => {
                setShowResults(true);
                await checkUsageBeforeSearch();
                await loadTableData({
                  jobTitle: jobTitleEntries
                    .filter((j) => j.name.trim())
                    .map((j) => j.name.trim())
                    .join(", "),
                  skillEntries,
                  location,
                  radius,
                  resumeUpdated,
                  education,
                  jobType,
                  travel,
                  relocation,
                  searchType,
                  booleanEntries,
                });
              }}
              style={{
                backgroundColor: "#9333ea",
                border: "none",
                borderRadius: "0",
                fontSize: "15px",
                fontWeight: 700,
                padding: "0 28px",
                letterSpacing: "0.05em",
                flexShrink: 0,
              }}
            />
          </div>

          {/* ── Search Type Radios + Advanced Options toggle ── */}
          <div
            style={{
              position: "relative",
              maxWidth: "1100px",
              margin: "14px auto 0",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flexWrap: "wrap",
              gap: "10px",
            }}
          >
            <div className="flex align-items-center gap-4">
              <div className="flex align-items-center gap-2">
                <RadioButton inputId="semantic" value="semantic" checked={searchType === "semantic"} onChange={() => setSearchType("semantic")} />
                <label htmlFor="semantic" style={{ color: "#e9d5ff", fontSize: "13px", cursor: "pointer" }}>
                  Semantic Search
                </label>
              </div>
              <div className="flex align-items-center gap-2">
                <RadioButton inputId="boolean" value="boolean" checked={searchType === "boolean"} onChange={() => setSearchType("boolean")} />
                <label htmlFor="boolean" style={{ color: "#e9d5ff", fontSize: "13px", cursor: "pointer" }}>
                  Semantic Boolean Keyword Search
                </label>
              </div>
            </div>

            {/* <Button label={showAdvanced ? "− HIDE ADVANCED OPTIONS" : "+ ADVANCED OPTIONS"} className="p-button-text p-0" style={{ color: "#e9d5ff", fontSize: "13px", fontWeight: 600 }} onClick={() => setShowAdvanced(true)} /> */}
          </div>

          {/* ── Advanced Options Panel ── */}
          {showAdvanced && (
            <div
              style={{
                position: "relative",
                maxWidth: "1100px",
                margin: "14px auto 0",
                backgroundColor: "rgba(255,255,255,0.08)",
                borderRadius: "6px",
                padding: "18px 20px",
              }}
            >
              <div className="flex flex-wrap gap-4">
                <div style={{ flex: "1 1 180px" }}>
                  <label style={{ display: "block", fontSize: "11px", fontWeight: 700, color: "#c4b5fd", textTransform: "uppercase", letterSpacing: "0.07em", marginBottom: "6px" }}>Resume Updated</label>
                  <Dropdown value={resumeUpdated} options={resumeUpdatedOptions} onChange={(e) => setResumeUpdated(e.value)} className="w-full" style={{ fontSize: "13px" }} />
                </div>
                <div style={{ flex: "1 1 180px" }}>
                  <label style={{ display: "block", fontSize: "11px", fontWeight: 700, color: "#c4b5fd", textTransform: "uppercase", letterSpacing: "0.07em", marginBottom: "6px" }}>Education Level</label>
                  <Dropdown value={education} options={educationOptions} onChange={(e) => setEducation(e.value)} className="w-full" style={{ fontSize: "13px" }} />
                </div>
                <div style={{ flex: "1 1 180px" }}>
                  <label style={{ display: "block", fontSize: "11px", fontWeight: 700, color: "#c4b5fd", textTransform: "uppercase", letterSpacing: "0.07em", marginBottom: "6px" }}>Job Type</label>
                  <Dropdown value={jobType} options={jobTypeOptions} onChange={(e) => setJobType(e.value)} className="w-full" style={{ fontSize: "13px" }} />
                </div>
                <div style={{ flex: "1 1 180px" }}>
                  <label style={{ display: "block", fontSize: "11px", fontWeight: 700, color: "#c4b5fd", textTransform: "uppercase", letterSpacing: "0.07em", marginBottom: "6px" }}>Willing to Travel</label>
                  <Dropdown value={travel} options={travelOptions} onChange={(e) => setTravel(e.value)} className="w-full" style={{ fontSize: "13px" }} />
                </div>
              </div>

              <Divider style={{ borderColor: "rgba(255,255,255,0.15)", margin: "14px 0" }} />

              <div className="flex align-items-center gap-2">
                <Checkbox inputId="relocation" checked={relocation} onChange={(e) => setRelocation(!!e.checked)} />
                <label htmlFor="relocation" style={{ fontSize: "13px", color: "#e9d5ff", cursor: "pointer" }}>
                  Include candidates willing to relocate
                </label>
              </div>
            </div>
          )}
        </div>
      )}

      {/* ── History Section ── */}
      {/* <div style={{ backgroundColor: "#fff", padding: "24px 40px", minHeight: "180px" }}> */}
      {/* Tabs */}
      {/* <div className="flex gap-4" style={{ borderBottom: "1px solid #e5e7eb", marginBottom: "0" }}>
          {["RECENT HISTORY", "SAVED HISTORY"].map((label, idx) => (
            <Button
              key={label}
              onClick={() => setActiveTab(idx)}
              className="p-button-text p-0"
              style={{
                fontSize: "12px",
                fontWeight: activeTab === idx ? 700 : 400,
                color: activeTab === idx ? "#111" : "#9ca3af",
                borderBottom: activeTab === idx ? "3px solid #22c55e" : "3px solid transparent",
                borderRadius: "0",
                padding: "0 0 10px 0",
                letterSpacing: "0.07em",
                marginBottom: "-1px",
              }}
              label={label}
            />
          ))}
        </div> */}

      {/* History Items */}
      {/* <div className="flex flex-column gap-0 mt-3">
          {(activeTab === 0 ? recentHistory : savedHistory).length === 0 ? (
            <p style={{ color: "#9ca3af", fontSize: "13px" }}>No history found</p>
          ) : (
            (activeTab === 0 ? recentHistory : savedHistory).map((item) => (
              <div key={item.id} style={{ padding: "10px 0", borderBottom: "1px solid #f3f4f6" }}>
                <Button
                  onClick={() => handleHistoryClick(item.query)}
                  className="p-button-text p-0"
                  style={{
                    color: "#2563eb",
                    fontSize: "13px",
                    textAlign: "left",
                    display: "block",
                    marginBottom: "3px",
                    lineHeight: "1.4",
                    fontWeight: 400,
                  }}
                  label={item.query}
                />
                <div className="flex align-items-center gap-1" style={{ color: "#9ca3af", fontSize: "11px" }}>
                  <i className="pi pi-clock" style={{ fontSize: "11px" }} />
                  <span>{item.date}</span>
                </div>
              </div>
            ))
          )}
        </div> */}
      {/* </div> */}

      <AdvancedOptions
        visible={showAdvanced}
        onHide={() => setShowAdvanced(false)}
        onSearch={() => {
          setShowAdvanced(false);
          loadTableData({ jobTitle, skillEntries, location, radius, resumeUpdated, education, jobType, travel, relocation, searchType });
          setShowResults(true);
        }}
      />
      {showResults && (
        <CandidateResults
          results={apiResults}
          totalResults={totalResults}
          isLoading={isLoading}
          searchQuery={[
            jobTitleEntries
              .filter((j) => j.name)
              .map((j) => j.name)
              .join(", "),
            skillEntries
              .filter((s) => s.name)
              .map((s) => s.name)
              .join(", "),
          ]
            .filter(Boolean)
            .join(", ")}
          useageData={useageData}
          onNewSearch={() => {
            setShowResults(false);
            setApiResults([]);
            setFirst(1);
          }}
          onCandidateClick={getViewAccess}
          onUpdateFilters={(filters) => {
            loadTableData({
              // jobTitle,
              jobTitle: jobTitleEntries
                .filter((j) => j.name.trim())
                .map((j) => j.name.trim())
                .join(", "),
              skillEntries,
              location,
              radius,
              searchType,
              booleanEntries,
              limitRelocate: filters.limitRelocate ?? relocation,
              limitVeterans: filters.limitVeterans ?? false,
              workAuth: filters.workAuth ?? "all",
              careerLevel: filters.careerLevel,
              yearsOfExperience: filters.yearsOfExperience,
              yearsExp: filters.yearsExp,
              expRequired: filters.expRequired,
              resumeUpdatedMaxAge: filters.resumeUpdatedMaxAge,
              resumeUpdatedMinAge: filters.resumeUpdatedMinAge,
              lastActiveMaxAge: filters.lastActiveMaxAge,
              candidateName: filters.candidateName,
              jobType: filters.jobType,
              citizenship: filters.citizenship,
              clearance: filters.clearance ?? filters.securityClearances,
              salary: filters.salary,
              salaryAmount: filters.salaryAmount,
              includeWithoutSalary: filters.includeWithoutSalary,
              travel: filters.willingnessToTravel ?? filters.travel,
              education: filters.minEducationLevel ?? filters.education,
              minEducationLevel: filters.minEducationLevel,
              willingnessToTravel: filters.willingnessToTravel,
              languageProficiencyLevels: filters.languageProficiencyLevels,
              degrees: filters.degrees,
              companies: filters.companies,
              jobTenure: filters.jobTenure,
            });
          }}
          filters={filters}
          setFilters={setFilters}
          first={first}
          setFirst={setFirst}
          onPage={onPage}
          totalReturned={totalReturned}
          suggestions={suggestions}
          searchLocation={searchLocation}
          location={location}
          setLocation={setLocation}
          skillEntries={skillEntries}
          removeSkill={removeSkill}
          updateSkillName={updateSkillName}
          toggleSkillImportance={toggleSkillImportance}
          addSkill={addSkill}
          jobTitleEntries={jobTitleEntries}
          addJobTitle={addJobTitle}
          removeJobTitle={removeJobTitle}
          updateJobTitle={updateJobTitle}
          radius={radius}
          radiusOptions={radiusOptions}
          setRadius={setRadius}
          booleanEntries={booleanEntries}
          setBooleanEntries={setBooleanEntries}
          searchType={searchType}
          setSearchType={setSearchType}
        />
      )}

      <Toast ref={toast} />

      <Dialog
        header={selectedCandidate?.name ?? "Candidate Profile"}
        visible={profileVisible}
        style={{ width: "90vw", maxWidth: "1400px" }}
        modal
        maximizable
        onHide={() => {
          setProfileVisible(false);
          setSelectedCandidate(null);
          setProfileLoading(false);
        }}
      >
        {selectedCandidate ? (
          <>
            {profileLoading && <ProfileSkeleton />}
            <div style={{ display: profileLoading ? "none" : "block" }}>
              <MonsterCandidateProfile
                visible={profileVisible}
                singleData={{ resumeID: selectedCandidate.textResumeID }}
                usageData={useageData}
                toast={toast}
                onLoaded={() => setProfileLoading(false)}
                searchQuery={[
                  jobTitleEntries
                    .filter((j) => j.name)
                    .map((j) => j.name)
                    .join(", "),
                  skillEntries
                    .filter((s) => s.name)
                    .map((s) => s.name)
                    .join(", "),
                ]
                  .filter(Boolean)
                  .join(", ")}
              />
            </div>
          </>
        ) : (
          profileLoading && <ProfileSkeleton />
        )}
        {/* {selectedCandidate &&  <MonsterCandidateProfile visible={profileVisible} singleData={{ resumeID: selectedCandidate.textResumeID }} toast={toast}  />} */}
      </Dialog>
    </div>
  );
};

export default SearchMonster;
